/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_Event_Group_MetadataInputs */



/**
* | output |
* | --- |
* | "Event Group Metadata" |
*
* @param {Metadata_Merge_Event_Group_MetadataInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_event_group_metadata = /** @type {((inputs?: Metadata_Merge_Event_Group_MetadataInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_Event_Group_MetadataInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Métadonnées du groupe d'événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisgruppen-Metadaten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Metadati del gruppo di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Метаданные группы событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Metadatos del grupo de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件组元数据")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループメタデータ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट समूह मेटाडेटा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Metadados do grupo de eventos")
	return /** @type {LocalizedString} */ ("Event Group Metadata")
});